'use client';

import React, { useMemo } from 'react';
import { useHits } from 'react-instantsearch';
import Link from 'components/consumer/Link';
import classNames from 'classnames';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useSearchUrlQueryParams from 'components/consumer/consumer-search/advanced-search/hooks/useSearchUrlQueryParams';
import { getBlogPath } from 'components/consumer/consumer-search/commons/helpers';

const ResultsHeader = ({ variant = 'desktop', children }) => (
  <div
    className={classNames('mx-0 my-2.5 text-base font-bold', {
      'text-gray': variant !== 'mobile',
      'text-brand block mt-[15px] mb-[7px]': variant === 'mobile',
    })}
  >
    {children}
  </div>
);

/**
 * StaticPageHits component - Next version (v7)
 * Uses useHits hook instead of legacy connectHits
 */
const StaticPageHitsNext = ({ toggleSearchOpen, variant = 'desktop' }) => {
  const { items: hits } = useHits();
  const { queryUrlParam: query } = useSearchUrlQueryParams();
  const currentPage = useUserCurrentPageType();

  const items = useMemo(
    () =>
      hits.map(hit => {
        const isStoriesURL = (hit?.url || '').startsWith('/stories');
        const finalURL = (isStoriesURL ? getBlogPath(hit.url) : hit.url) || '';
        return { objectID: hit.objectID, page: hit.page, finalURL };
      }),
    [hits]
  );

  if (!items.length) {
    return null;
  }

  const handleClick = async () => {
    await toggleSearchOpen?.();
    avo.productsSearched({
      query,
      location: currentPage,
      searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK,
    });
  };

  return (
    <div className="[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 static-pages">
      <ResultsHeader variant={variant}>Pages</ResultsHeader>
      <div>
        {items.map(item => (
          <div key={item.objectID}>
            <Link
              className={classNames(
                'text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8',
                {
                  'block mr-2.5 text-[#585858]': variant === 'desktop',
                  'text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block':
                    variant === 'mobile',
                }
              )}
              onClick={handleClick}
              to={item.finalURL}
            >
              {item.page}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StaticPageHitsNext;
